// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/910121ea345abb2a8eb4.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"bc1adb74eb8fa12df714","125":"9dca494b960bb04b0bcc","126":"b74507ad5c7c7549f59c"}[chunkId] + ".chunk.js";
};